import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const fetchParsedTrees = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchParsedTreesAction => {
  return {
    type: actionsTypes.FETCH_PARSEDTREES,
    query,
    callback
  };
};

export const addParsedTree = (parsedTree: actionsInterfaces.IParsedTree, callback: IAsyncActionCallback): actionsInterfaces.IPostParsedTreeAction => {
  return {
    type: actionsTypes.ADD_PARSEDTREE,
    parsedTree,
    callback
  };  
};

export const setParsedTrees = (parsedTrees: actionsInterfaces.IParsedTree): actionsInterfaces.ISetParsedTreesAction => {
  return {
    type: actionsTypes.SET_PARSEDTREE,
    parsedTrees,
  };
};

export const getParsedTree = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchParsedTreeAction => {
  return {
    type: actionsTypes.GET_PARSEDTREE_INFO,
    query,
    callback
  };  
};

export const setParsedTree = (parsedTree: actionsInterfaces.IParsedTree): actionsInterfaces.ISetParsedTreeAction => {
  return {
    type: actionsTypes.SET_PARSEDTREE_INFO,
    parsedTree,
  };
};

export const addSuccessParsedTree = (response: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS_PARSEDTREE,
    response,
  };
};

export const fetchSearchParsedTree = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchSearchAction => {
  return {
    type: actionsTypes.FETCH_SEARCH_PARSEDTREE,
    query,
    callback
  };
};

export const setSearchParsedTree = (searches: actionsInterfaces.IParsedTree): actionsInterfaces.ISetSearchAction => {
  return {
    type: actionsTypes.SET_SEARCH_PARSEDTREE,
    searches,
  };
};

export const updateParsedTree = (parsedTree: actionsInterfaces.IParsedTree, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateParsedTreeAction => {
  return {
    type: actionsTypes.UPDATE_PARSEDTREE,
    parsedTree,
    callback
  };
};

export const updateParsedTreeElements = (updateElementsInfo: actionsInterfaces.UpdateElementsInfo, saveVersion?:boolean,callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateParsedTreeElementsAction => {
  return {
    type: actionsTypes.UPDATE_PARSEDTREE_ELEMENTS,
    updateElementsInfo,
    saveVersion,
    callback
  };
};

export const updateArtboardPreview = (data: string[], id:string, name:string, inmediate?: boolean, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateArtboardPreviewAction => {
  return {
    type: actionsTypes.UPDATE_ARTBOARD_PREVIEW,
    data,
    id,
    name,
    inmediate,
    callback
  };
};


export const exportArtboardMedia = (data: string[], dealerId:string, collection:string, prefix:string, access_token:string, id:string,  name:string, overwrite?:boolean, inmediate?: boolean, callback?: (result: any, error: any) => void): actionsInterfaces.IExportArtboardMediaAction => {
  return {
    type: actionsTypes.EXPORT_ARTBOARD_MEDIA,
    data,
    dealerId,
    collection,
    prefix,
    access_token,
    id,
    name,
    overwrite,
    inmediate,
    callback
  };
};


export const updateParsedTreeField = (updateFieldInfo: actionsInterfaces.IUpdateFieldInfo,callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateParsedTreeFieldAction => {
  return {
    type: actionsTypes.UPDATE_PARSEDTREE_FIELD,
    updateFieldInfo,
    callback
  };
};

export const updateParsedTreeFieldTags = (updateFieldTagsInfo: actionsInterfaces.IUpdateFieldTagsInfo,callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateParsedTreeFieldTagsAction => {
  return {
    type: actionsTypes.UPDATE_PARSEDTREE_FIELDTAGS,
    updateFieldTagsInfo,
    callback
  };
};

export const updateParsedTreeFieldsTags = (updateFieldsTagsInfo: actionsInterfaces.IUpdateFieldsTagsInfo,callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateParsedTreeFieldsTagsAction => {
  return {
    type: actionsTypes.UPDATE_PARSEDTREE_FIELDSTAGS,
    updateFieldsTagsInfo,
    callback
  };
};

export const updateParsedTreeTemplateFields = (updateTemplateFieldsInfo: actionsInterfaces.IUpdateTemplateFieldsInfo,callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateParsedTreeTemplateFieldsAction => {
  return {
    type: actionsTypes.UPDATE_PARSEDTREE_TEMPLATEFIELDS,
    updateTemplateFieldsInfo,
    callback
  };
};

export const fetchCounterParsedTree = (filter?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchCounterAction => {
  return {
    type: actionsTypes.FETCH_COUNTER_PARSEDTREE,
    filter,
    callback
  };
};

export const setCounterParsedTree = (counter: actionsInterfaces.IParsedTree): actionsInterfaces.ISetCounterAction => {
  return {
    type: actionsTypes.SET_COUNTER_PARSEDTREE,
    counter,
  };
};

export const setUpdateParsedTreeElements = (updatedElementsResponse: any|undefined): actionsInterfaces.ISetUpdateParsedTreeElements => {
  return {
    type: actionsTypes.SET_UPDATE_PARSEDTREE_ELEMENTS,
    updatedElementsResponse,    
  };
};

export const setUpdateParsedTreeField = (updatedFieldResponse: any|undefined): actionsInterfaces.ISetUpdateParsedTreeField => {
  return {
    type: actionsTypes.SET_UPDATE_PARSEDTREE_FIELD,
    updatedFieldResponse,
  };
};

export const setUpdateParsedTreeFieldTags = (updatedFieldTagsResponse: any|undefined): actionsInterfaces.ISetUpdateParsedTreeFieldTags => {
  return {
    type: actionsTypes.SET_UPDATE_PARSEDTREE_FIELDTAGS,
    updatedFieldTagsResponse,
  };
};

export const setUpdateParsedTreeFieldsTags = (updatedFieldsTagsResponse: any|undefined): actionsInterfaces.ISetUpdateParsedTreeFieldsTags => {
  return {
    type: actionsTypes.SET_UPDATE_PARSEDTREE_FIELDSTAGS,
    updatedFieldsTagsResponse,
  };
};

export const setUpdateParsedTreeTemplateFields = (updatedTemplateFieldsResponse: any|undefined): actionsInterfaces.ISetUpdateParsedTreeTemplateFields => {
  return {
    type: actionsTypes.SET_UPDATE_PARSEDTREE_TEMPLATEFIELDS,
    updatedTemplateFieldsResponse,
  };
};


export const fetchParsedTreeChanges = (id:string, start:number, length:number,version?:boolean,  callback?: (result: any, error: any) => void): actionsInterfaces.IFetchParsedTreeChangesAction => {
  return {
    type: actionsTypes.FETCH_PARSEDTREECHANGES,
    id,    
    start,
    length,
    version,
    callback
  };
};

export const setParsedTreeChanges = (parsedTreeChange: actionsInterfaces.IParsedTreeChange): actionsInterfaces.ISetParsedTreeChangesAction => {
  return {
    type: actionsTypes.SET_PARSEDTREECHANGES,
    parsedTreeChange,
  };
};


export const getParsedTreeChange = (id:string, callback?: (result: any, error: any) => void): actionsInterfaces.IGetParsedTreeChangeAction => {
  return {
    type: actionsTypes.GET_PARSEDTREECHANGE,
    id,
    callback
  };  
};


export const restoreParsedTreeChange = (id:string, parsedTree: string,userData:any , callback?: (result: any, error: any) => void): actionsInterfaces.IRestoreParsedTreeChangeAction => {
  return {
    type: actionsTypes.RESTORE_PARSEDTREECHANGE,
    id,
    parsedTree,
    userData,
    callback
  };
};